import React from "react";
import BookingMarketplacePage from "./BookingMarketplacePage";

/**
 * Booking owns its own public landing entry.
 * Public booking discovery now has its own listing surface so businesses
 * with public booking pages and event types can be discovered directly.
 */
export default function BookingPublicLandingPage(): JSX.Element {
  return <BookingMarketplacePage />;
}
